import script from "./ODetalhesEvento.vue?vue&type=script&lang=ts&setup=true"
export * from "./ODetalhesEvento.vue?vue&type=script&lang=ts&setup=true"

import "./ODetalhesEvento.vue?vue&type=style&index=0&id=69217b92&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69217b92"]])

export default __exports__